module.exports = __webpack_public_path__ + "img/ValidationReport_4.fb782824.jpg";